/**
 * Shared Framer Motion easing curves.
 *
 * Use these instead of inlining bezier tuples so timing stays consistent
 * across pages and we only tune in one place.
 */

/** Quartic ease-out — strong start, slow finish. Default for reveals. */
export const EASE_OUT_EXPO = [0.16, 1, 0.3, 1] as const;

/** Softer ease-out — gentler arc, used for slow accordion-style chevron rotations. */
export const EASE_OUT_SMOOTH = [0.44, 1, 0.36, 1] as const;
